import { computed, defineComponent, onBeforeUnmount, onMounted, ref, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'ProfileCard',
    props: {
        profile: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const isOpened = ref(false);
        const rootElement = ref();
        const isTooltipDataExist = computed(() => {
            return (props.profile.body || []).length || (props.profile.sections || []).length;
        });
        function handleBlackout() {
            isOpened.value = false;
        }
        function handleClickOutside({ target }) {
            if (rootElement.value && !rootElement.value.contains(target)) {
                isOpened.value = false;
            }
        }
        function handleKeyup({ code = '' }) {
            if (code === 'Escape') {
                isOpened.value = false;
            }
        }
        function toggleTooltip() {
            isOpened.value = !isOpened.value;
        }
        onBeforeUnmount(() => {
            window.removeEventListener('click', handleClickOutside);
            window.removeEventListener('keyup', handleKeyup);
        });
        onMounted(() => {
            window.addEventListener('click', handleClickOutside);
            window.addEventListener('keyup', handleKeyup);
        });
        return {
            css,
            handleBlackout,
            isOpened,
            isTooltipDataExist,
            rootElement,
            toggleTooltip,
        };
    },
});
